<template>
  <v-app id="app">
    <cookie-consent :piwik-instance="$piwik"/>
    <Header />
    <v-main>
      <Main />
    </v-main>
  </v-app>
</template>

<script>
import '@deu/deu-cookie-consent/dist/deu-cookie-consent.css';
import Header from "@/components/header/Header.vue";
import CookieConsent from '@deu/deu-cookie-consent';
import Main from './components/Main.vue';

import { config as CONFIG } from '../config/config';

export default {
  name: 'App',
  components: {
    Header,
    Main,
    CookieConsent,
  },
  data() {
    return {
      title: CONFIG.title,
      link: CONFIG.link,
      piwikId: '',
    };
  },
};
</script>

<style lang="scss">
/***********************************
  SITE BRANDING
***********************************/

.v-application a {
  color: #0E47CB ;
}

.ecl-link {
  color: #0E47CB !important;
}

.ecl-tabs__link {
    background-color: transparent;
    border-bottom: 1px solid #cfcfcf;
    border-radius: 0;
    color: #707070 !important;
    display: block;
    font: normal normal 400 1rem/1.25rem arial,sans-serif;
    margin-bottom: -1px;
    padding: 1rem 0.75rem;
    text-decoration: none;

}

.ecl-tabs__link--active {
    background-color: transparent;
    border-bottom: 1px solid #cfcfcf;
    border-top: 4px solid #0E47CB !important;
    border-radius: 0;
    color: #0E47CB !important;
    display: block;
    font: normal normal 400 1rem/1.25rem arial,sans-serif;
    margin-bottom: -1px;
    padding: 1rem 0.75rem;
    text-decoration: none;
    background-color: transparent !important;
    border-top: transparent solid 4px;
}

#block-edp3-branding {
  padding: 20px 20px 0px 20px;
  @media only screen and (max-width: 599px) {
    display: flex;
    align-items: center;
  }
}

#block-edp3-branding a {
  text-decoration: none;
  display: inline-block;
  overflow: hidden;
}

#block-edp3-branding a img {
  height: 45px;
  margin-right: 10px;

  @media only screen and (max-width: 599px) {
    height: 35px;
  }
}

#block-edp3-branding .site-branding__text {
  display: inline-block;
}

#block-edp3-branding div a {
  line-height: 45px !important;
  font-size: 15px !important;
  color: #0F62AE !important;
  padding-bottom: 5px !important;
  padding-left: 5px !important;
  display: inline-block !important;
  text-transform: uppercase !important;

  @media only screen and (max-width: 599px) {
    font-size: 10px !important;
    overflow: unset;
    line-height: 20px !important;
  }

  @media only screen and (max-width: 400px) {
    width: 140px;
    font-size: 9px !important;
  }
}

#block-edp3-branding div a h1 {
  font-weight: 300 !important;
}

#block-edp3-branding div a strong {
  font-weight: bold;
}

#block-edp3-branding .edp-logo {
  width: 417px;
  height: auto;

  &--three-rows {
    height: 50px;
    width: auto;
  }
}
</style>
